import React, { useState } from "react";
import { Radio } from "antd";
import { ModalBase } from "../../../../../Components/Modais/ModalBase/ModalBase";
import ButtonActions from "../../../../../Components/Buttons/ButtonActions/ButtonActions";
import { useValidateCrfa } from "../../hooks/useValidateCrfa";
import Spinner from "../../../../../Components/Spinner";

// Motivos de recusa enviados para a API
const REJECTION_REASONS = {
  DOCUMENTO_INELEGIVEL: "DOCUMENTO_INELEGIVEL",
  TIPO_DOCUMENTO_INVALIDO: "TIPO_DOCUMENTO_INVALIDO",
  ARQUIVO_CORROMPIDO: "ARQUIVO_CORROMPIDO",
  DOCUMENTO_INVALIDO: "DOCUMENTO_INVALIDO",
};

const ModalRejected = ({ open, onClose, selectedDocument, getPendingCrfa }) => {
  const { rejectedCrfa } = useValidateCrfa();
  
  const [isLoading, setIsLoading] = useState(false);

  // Armazena o motivo selecionado
  const [selectedValue, setSelectedValue] = useState(null);

  // Atualiza o motivo selecionado
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  // Limpa a seleção e fecha o modal
  const handleClose = () => {
    setSelectedValue(null);
    onClose();
  };

  // Envia a recusa e atualiza a tabela
  const handleRejected = async () => {
    setIsLoading(true);

    try {
      await rejectedCrfa(selectedDocument.user_sub, "rejected", selectedValue);

      // Atualiza a lista de documentos pendentes
      await getPendingCrfa();

      handleClose();
    } catch (error) {
      console.log("Erro ao reprovar:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalBase
      animated={false}
      open={open}
      onCancel={handleClose}
      title="Selecione o motivo da recusa do documento:"
      width={600}
      footerAlign="center"
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            width: "100%",
          }}
        >
          <ButtonActions
            variant="outline"
            onClick={handleClose}
            text="FECHAR"
          />

          <ButtonActions
            variant="danger"
            text="CONFIRMAR RECUSA"
            disabled={!selectedValue || isLoading}
            onClick={handleRejected}
          />
        </div>
      }
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <Radio.Group
          onChange={handleChange}
          value={selectedValue}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "20px",
            width: "100%",
            height: 300,
            padding: "24px 16px",
            boxSizing: "border-box",
          }}
        >
          <Radio value={REJECTION_REASONS.DOCUMENTO_INELEGIVEL}>
            Documento inelegível
          </Radio>

          <Radio value={REJECTION_REASONS.TIPO_DOCUMENTO_INVALIDO}>
            Documento enviado não se trata de carteirinha do CRFa, diploma de
            graduação ou declaração de regularidade.
          </Radio>

          <Radio value={REJECTION_REASONS.ARQUIVO_CORROMPIDO}>
            Arquivo corrompido e/ou com erro
          </Radio>

          <Radio value={REJECTION_REASONS.DOCUMENTO_INVALIDO}>
            O documento não é válido
          </Radio>
        </Radio.Group>
      )}
    </ModalBase>
  );
};

export default ModalRejected;
